import api from '@/services/api/api'

class TechniquesService {
  getAllTechniques () {
    return api.get('technique').then(result => {
      return result.data
    })
  }

  saveTechnique (technique) {
    return api.post('technique', technique)
  }

  removeTechnique (technique) {
    return api.delete('technique/' + technique.id)
  }
}

export default new TechniquesService()



// WEBPACK FOOTER //
// ./src/services/codebooks/TechniquesService.js